import React from 'react'
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './HeaderBack.css'
export default function HeaderBack({ link, title, rightSlot }) {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);
    return (
        <div className='headerBack'>
            <div onClick={goBack}>
                <FontAwesomeIcon icon={faArrowLeft} />
            </div>
            <span>{title}</span>
            {rightSlot && <div className='headerBack-right'>{rightSlot}</div>}
        </div>
    )
}
